import { css } from 'styled-components';
import { breakpoints } from '../../breakpoints';
import { cssfonts } from '../cssfonts';

const common = css`
  font-size: 2.25rem; /* 36px */
  line-height: 1.2; /* 36/44 */

  @media (min-width: ${breakpoints.desktop}) {
    font-size: 3.25rem; /* 52px */
    line-height: 1.3; /* 52/68 */
  }
`;

export const h2 = {
  extrabold: css`
    ${cssfonts.exbold}
    ${common}
  `,
  bold: css`
    ${cssfonts.bold}
    ${common}
  `,
  regular: css`
    ${cssfonts.regular}
    ${common}
  `,
  light: css`
    ${cssfonts.light}
    ${common}
  `,
} as const;

